import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaChevronLeft,
  FaChevronRight,
  FaImages,
  FaTrash,
  FaEdit,
} from "react-icons/fa";
import Swal from "sweetalert2";
import EditPlotModal from "./EditPlot";

const ListPlot = () => {
  const [plot, setPlot] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);

  const handleEdit = (plot) => {
    setSelectedPlot(plot);
    setShowModal(true);
  };

  const fields = [
    "Sr. No",
    "Title",
    "Address",
    "Description",
    "Plot Details",
    "Price",
    "Size (sqft)",
    "Availability",
    "Approved",
    "Key Features",
    "Contact No",
    "Seller Name",
    // "Distance From",
    // "Actions",
  ];

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/get_all_plots`
        );
        const data = await response.json();


        setPlot(data || []);
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchTeamMembers();
  }, []);

  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(plot.length / rowsPerPage);
  const paginatedData = plot.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }

    return pages.map((page, i) =>
      page === "..." ? (
        <span key={i} className="px-2 text-gray-500 select-none">
          ...
        </span>
      ) : (
        <button
          key={i}
          onClick={() => setCurrentPage(page)}
          className={`px-3 py-1 rounded-full text-sm font-medium ${
            currentPage === page
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {page}
        </button>
      )
    );
  };

  const handleDelete = async (id) => {

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/delete_plot/${id}`,
          {
            method: "DELETE",
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          // setPlot((prev) => prev.filter((member) => member._id !== id));
          const updatedList = plot.filter((member) => member._id !== id);
          setPlot(updatedList);

          const totalPagesAfterDelete = Math.ceil(
            updatedList.length / rowsPerPage
          );
          if (currentPage > totalPagesAfterDelete) {
            setCurrentPage(totalPagesAfterDelete);
          }

          Swal.fire({
            title: "Deleted!",
            text: "Plot has been deleted. sucessfully",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: data.message || "Failed to delete Plot.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire({
          title: "Error!",
          text: "Server error while deleting.",
          icon: "error",
        });
      }
    }
  };

  return (
    <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-xl shadow-lg overflow-auto "
      >
        <div className="px-6 py-4 border-b bg-gradient-to-r from-blue-700 to-cyan-500 text-white text-lg font-semibold rounded-t-xl">
          List Plots
        </div>
        <div className="overflow-x-auto text-center">
          <table className="min-w-full text-sm text-center">
            <thead className="bg-blue-100 text-gray-700">
              <tr>
                {fields.map((field, idx) => (
                  <th
                    key={idx}
                    className="px-4 py-3 font-medium whitespace-nowrap"
                  >
                    {field}
                  </th>
                ))}
                <th className="px-4 py-3 font-medium whitespace-nowrap w-72">
                  Distance From
                </th>
                <th className="px-4 py-2 border">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {paginatedData.length > 0 ? (
                paginatedData.map((row, idx) => (
                  <motion.tr
                    key={idx}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    className="hover:bg-blue-50"
                  >
                    <td className="px-4 py-3">
                      {(currentPage - 1) * rowsPerPage + idx + 1}
                    </td>
                    <td className="px-4 py-3">{row.title}</td>
                    <td className="px-4 py-3">{row.address}</td>
                    <td className="px-4 py-3">{row.description}</td>
                    <td className="px-4 py-3">{row.plotDetails}</td>
                    <td className="px-4 py-3">₹{row.price.toLocaleString()}</td>
                    <td className="px-4 py-3">{row.size}</td>
                    <td className="px-4 py-3">{row.availability}</td>
                    <td className="px-4 py-3">{row.approved}</td>
                    <td className="px-4 py-3">{row.keyFeatures}</td>
                    <td className="px-4 py-3">{row.contactNo}</td>
                    <td className="px-4 py-3">{row.sellerName}</td>
                    <td className="px-4 py-3 w-72">
                      <ul className="list-disc list-inside space-y-1">
                        {row.distanceFrom?.map((item, i) => (
                          <li key={item._id || i}>
                            {item.locality} – {item.distanceFrom}
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex justify-center items-center h-full gap-4">
                        <button
                          onClick={() => handleEdit(row)}
                          className="text-blue-600 hover:text-blue-800 transition"
                          title="Edit"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDelete(row._id)}
                          className="text-red-600 hover:text-red-800 transition"
                          title="Delete"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </motion.tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="py-6 text-gray-500 text-center">
                    <div className="flex flex-col items-center justify-center py-20">
                      <FaImages className="text-5xl text-gray-300 mb-4" />
                      <p className="text-xl text-gray-500 font-medium">
                        No Plot available.
                      </p>
                      <p className="text-sm text-gray-400 mt-1">
                        Once Plots are uploaded, they’ll show up here.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </motion.div>

      {/* Pagination Controls */}
      {plot.length > 10 && (
        <div className="flex justify-center items-center mt-6 gap-2 flex-wrap">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <FaChevronLeft size={14} />
          </button>
          {renderPageNumbers()}
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            <FaChevronRight size={14} />
          </button>
        </div>
      )}

      {showModal && (
        <EditPlotModal
          plot={selectedPlot}
          onClose={() => setShowModal(false)}
          onUpdate={(updatedPlot) => {
            setPlot((prev) =>
              prev.map((p) => (p._id === updatedPlot._id ? updatedPlot : p))
            );
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
};

export default ListPlot;
